(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["subcollectionlist"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sub-collections-scroll')) {
  class SubCollectionsScroll extends HTMLElement {
    connectedCallback() {
      this.scroller = this.querySelector('.sub-collections__scroller');
      if (!this.scroller) return;

      this.update = this.update.bind(this);
      this.scroller.addEventListener('scroll', this.update, { passive: true });

      // Recalculate when the viewport or the list size changes
      this.resizeObserver = new ResizeObserver(this.update);
      this.resizeObserver.observe(this.scroller);
      if (this.scroller.firstElementChild) {
        this.resizeObserver.observe(this.scroller.firstElementChild);
      }

      this.update();
    }

    disconnectedCallback() {
      this.scroller?.removeEventListener('scroll', this.update);
      this.resizeObserver?.disconnect();
    }

    update() {
      const { scrollWidth, clientWidth, scrollLeft } = this.scroller;
      const maxScroll = scrollWidth - clientWidth;
      const isScrollable = maxScroll > 1;

      this.classList.toggle('is-scrollable', isScrollable);
      if (!isScrollable) return;

      const visibleRatio = clientWidth / scrollWidth;
      const progress = scrollLeft / maxScroll;

      this.style.setProperty('--thumb-size', `${visibleRatio * 100}%`);
      this.style.setProperty('--thumb-offset', `${progress * (1 - visibleRatio) * 100}%`);
    }
  }

  customElements.define('sub-collections-scroll', SubCollectionsScroll);
}
  } catch(e) { console.error(e); }
})();

})();
